// Receber o seletor do campo saldo
let inputPrice = document.getElementById('saldo');

// Aguardar o usuário digitar valor no campo
inputPrice.addEventListener('input', function () {

    // Obter o valor atual removendo qualquer caractere que não seja número
    let valuePrice = this.value.replace(/[^\d]/g, '');

    // Adicionar os separadores de milhares
    var formattedPrice = (valuePrice.slice(0, -2).replace(/\B(?=(\d{3})+(?!\d))/g, '.')) + '' + valuePrice.slice(-2);

    // Adicionar a vírgula e até dois dígitos se houver centavos
    if (formattedPrice.length > 2) {
        formattedPrice = formattedPrice.slice(0, -2) + ',' + formattedPrice.slice(-2);
    }

    // Atualizar o valor do campo
    this.value = formattedPrice;

});

//SCRIPT DO TOOLTIP
$(function () {
    $('[data-toggle="tooltip"]').tooltip()
})


function imprimirPeticao() {
    var conteudo = document.getElementById('imprimir').innerHTML; // Seleciona a área da petição
    var janelaImpressao = window.open('', '_blank'); // Abre uma nova janela para impressão
    janelaImpressao.document.open();
    janelaImpressao.document.write(`<html>   <head>   <title>Imprimir Petição</title>
                                                                    <style>
                                                                    body {
                                                                    font-family: times, sans-serif; margin: 20px; padding-left: 40px;
                                                                    }
                                                                    .negrito {
                                                                    font-weight: bold;
                                                                    }
                                                                    .maiusculas {
                                                                    text-transform: uppercase;
                                                                    text-align: justify;
                                                                    font-weight: bold;
                                                                    }
                                                                    p {
                                                                    text-align: justify;
                                                                    }
                                                                    .partes {
                                                                    font-weight: bold;  text-transform: uppercase;
                                                                    } .no-print
                                                                    { display: none !important;
                                                                     }
                                                                    </style>
                                                                    </head>
                                                                    <body>
                                                                    ${conteudo} <!-- Insere o conteúdo da petição -->
                                                                    </body>
                                                                    </html>
                                                                    `);
    janelaImpressao.document.close();
    janelaImpressao.print(); // Inicia a impressão
    janelaImpressao.close(); // Fecha a janela após a impressão
}

function exportarPeticao(formato) {
    // Obtém o conteúdo da petição
    var conteudo = document.getElementById('imprimir').innerText;

    // Remove os botões e elementos com classe 'no-print'
    var tempDiv = document.createElement('div');
    tempDiv.innerHTML = conteudo;
    var elementsToRemove = tempDiv.getElementsByClassName('no-print');
    while (elementsToRemove.length > 0) {
        elementsToRemove[0].parentNode.removeChild(elementsToRemove[0]);
    }

    // Limpa o conteúdo
    conteudo = tempDiv.innerText;

    // Cria um blob com o conteúdo
    var blob;
    if (formato === 'txt') {
        blob = new Blob([conteudo], { type: 'text/plain;charset=utf-8' });
    } else if (formato === 'doc') {
        // Adiciona formatação básica para documento do Word
        var htmlContent = `
                        <html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word'>
                        <head>
                            <meta charset="utf-8">
                            <title>Petição</title>
                        </head>
                        <body>
                            <div style="font-family: Times New Roman; font-size: 12pt;">
                                ${conteudo}
                            </div>
                        </body>
                        </html>`;
        blob = new Blob([htmlContent], { type: 'application/msword' });
    }

    // Cria um link para download
    var url = window.URL.createObjectURL(blob);
    var a = document.createElement('a');
    var timestamp = new Date().getTime();
    var filename = 'peticao_' + timestamp + '.' + formato;

    a.href = url;
    a.download = filename;

    // Anexa o link ao documento
    document.body.appendChild(a);

    // Simula o clique no link
    a.click();

    // Remove o link
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
}

